module.exports = __webpack_public_path__ + "img/toLearnpic_shipin.934d935a.png";